var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("확인")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg"},[_c('img',{attrs:{"src":require("@/assets/img/order/ic_notice.svg")}}),_c('span',[_vm._v(" 픽업시간이 지났거나 임박하였습니다."),_c('br'),_vm._v("변경된 시간을 다시 확인해 주세요! ")])])
}]

export { render, staticRenderFns }